import { observer } from 'mobx-react-lite'
import { FontWeight } from './components/FontWeight'
import { track } from '@tldraw/tldraw'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { useRelevantStyles } from 'components/VisualStudioPlayground/VisualEditor/hooks/useRelevantStyles'
import {
  FontFamilyStyle,
  FontSizeStyle,
  FontWeightStyle,
  LetterSpacingStyle,
  LineHeightStyle,
} from 'components/VisualStudioPlayground/VisualEditor/StyleProps'
import { FontSliders } from './components/FontSliders'
import Styles from './FontStylesPanel.module.scss'

export const FontStylesPanel = track(
  observer(() => {
    const editor = useEditor()
    const relevantStyles = useRelevantStyles(editor)

    if (!editor || !relevantStyles) return null

    const { styles } = relevantStyles

    const fontFamily = styles.get(FontFamilyStyle)
    const fontWeight = styles.get(FontWeightStyle)
    const fontSize = styles.get(FontSizeStyle)
    const lineHeight = styles.get(LineHeightStyle)
    const letterSpacing = styles.get(LetterSpacingStyle)

    return (
      <div className={Styles.container}>
        {fontWeight && fontFamily && <FontWeight editor={editor} style={fontWeight} fontFamilyStyle={fontFamily} />}
        {fontSize && lineHeight && letterSpacing && (
          <FontSliders
            editor={editor}
            fontSizeStyle={fontSize}
            lineHeightStyle={lineHeight}
            letterSpacingStyle={letterSpacing}
          />
        )}
      </div>
    )
  }),
)
